import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import ChartComponent from "../Highcharts/ChartComponent";
import { commoditiesBarConfig } from "../Highcharts/chartconfig";
import axios from "axios";
import Loader from "./Loader";

function Commodities({ requestData }) {
  const [chartCounter, setChartCounter] = useState([]);
  const [chartKeys, setChartKeys] = useState([]);

  useEffect(() => {
    let requestBody = {
      communityId: "fee5c0c217af285485abb2e583cb806c",
      distributionOnCasesIdentifier: [
        "Drugs/Medicines",
        "Consumables",
        "Nutritional Supplements",
      ],
      languageId: 1,
      serviceId: 455,
    };
    if (Object.keys(requestData).length > 0) {
      let oRequest = { ...requestBody, ...requestData };
      if (
        (requestData?.globalFilters?.dateFilter.to !== "" &&
          requestData?.globalFilters?.dateFilter.from !== "") ||
        (requestData.questionIds != null &&
          requestData.selectedOption != null) ||
        (requestData.subQuestionIds != null &&
          requestData.selectedOption != null) ||
        requestData.serviceIdFilter != null
      ) {
        getCommoditiesData(oRequest);
      }
    } else {
      getCommoditiesData(requestBody);
    }
  }, [requestData]);

  let getCommoditiesData = async (data) => {
    try {
      let res = await axios.post(
        `${process.env.REACT_APP_API_KEY}/opendashboard/casesReportedUnderCommodities`,
        data
      );
      let formatedData = res.data.data;
      formatData(formatedData);
    } catch (error) {
      console.log(error);
    }
  };

  const formatData = (data) => {
    let sortedData = data.sort((a, b) => {
      let keyA = Object.keys(a)[0];
      let keyB = Object.keys(b)[0];
      return keyA.localeCompare(keyB);
  });
    let firstKeys = Object.keys(sortedData);
    let sortedObj = {};

    firstKeys.forEach((item, index) => {
      let innerKeys = Object.keys(sortedData[item]);
      let obj = {};
      obj[innerKeys] = sortedData[item][innerKeys];
      sortedObj = { ...sortedObj, ...obj };
    });

    let updatedSorted = Object.keys(sortedObj);

  
    // Below map loop is used to calculate the percentage
    const transformedArr = updatedSorted.map((item) => {
      let d = item;
      // Find total sum of each object
      const totalSum = Object.keys(sortedObj[item]).reduce((prev, key) => {
        return prev + sortedObj[item][key];
      }, 0);

      return Object.keys(sortedObj[item]).reduce((prev, key) => {
        if (sortedObj[item][key] == 0 && totalSum == 0) {
          return { ...prev, [key]: 0 };
        } else {
          return {
            ...prev,
            [key]: [
              Math.round((sortedObj[item][key] / totalSum) * 100),
              sortedObj[item][key],
            ],
          };
        }
      }, {});
    });

    let percentObj = {};
    updatedSorted.forEach((item, index) => {
      percentObj[item] = transformedArr[index];
    });

    let allKeysArr = [];
    updatedSorted.forEach((item, index) => {
      allKeysArr = [...allKeysArr, ...Object.keys(percentObj[item])];
    });

    let allUniqueKeyArr = allKeysArr.filter(
      (item, index) => allKeysArr.indexOf(item) === index
    );

    let colourArr = [
      "#4472C4",
      "#385723",
      "#FFC000",
      "#C00000",
      "#5B9BD5",
      "#70AD47",
      "#D9D9D9",
    ];

    let finalArr = [];

    const randomIntFromInterval = (min, max) => {
      return Math.floor(Math.random() * (max - min + 1) + min);
    };

    const rndInt = randomIntFromInterval(1, 6);
    allUniqueKeyArr.forEach((ele, index) => {
      let mainArr = [];
      let obj = [];
      updatedSorted.forEach((item, ind) => {
        let arr = [];
        let obj = {};
        if (Object.keys(percentObj[item]).includes(ele)) {
          arr = [
            ...arr,
            { percent: percentObj[item][ele][0], y: percentObj[item][ele][1] },
          ];
        } else {
          arr = [...arr, 0];
        }
        mainArr = [...mainArr, ...arr];
      });
      finalArr = [
        ...finalArr,
        {
          name: ele,
          data: mainArr,
          color:
            colourArr[index] !== undefined
              ? colourArr[index]
              : colourArr[randomIntFromInterval(0, colourArr.length)],
        },
      ];
    });
    let showChartkeys = Object.keys(percentObj);
    setChartKeys(showChartkeys);
    setChartCounter(finalArr);
  };

  return (
    <Card>
      <Card.Body className="pb-3">
        <h5>Summary of cases reported under commodities</h5>
        {chartCounter && chartCounter.length > 0 ? (
          <ChartComponent
            options={commoditiesBarConfig(chartCounter, chartKeys)}
          />
        ) : (
          <Loader />
        )}
      </Card.Body>
    </Card>
  );
}

export default Commodities;
